const popup = document.querySelector(".rn-start-open");
const isPopup = localStorage.getItem("start-popup");

document.addEventListener("DOMContentLoaded", (event) => {
  if (!isPopup || isPopup === "false") {
    setTimeout(() => popup?.classList.add("is-active"), 1000);
  }
});

const closePopup = () => {
  popup?.classList.remove("is-active");
  localStorage.setItem("start-popup", "true");
};

const nextStep = (event) => {
  const current = event.target.closest(".rn-start-open-content-inner-step");
  const next = current.nextElementSibling;
  current.classList.remove("is-active");
  next.classList.add("is-active");
};

// Add event listeners if popup exists
popup
  ?.querySelector(".rn-start-open-content-inner-step1-is-no")
  ?.addEventListener("click", closePopup);
popup
  ?.querySelector(".rn-start-close-button")
  ?.addEventListener("click", closePopup);
popup
  ?.querySelector(".rn-start-open-content-inner-step1-is-yes")
  ?.addEventListener("click", nextStep);

const sidebar = document.querySelector(".rn-wishlist-sidebar-wrap");

if (sidebar) {
  [
    "status-saved-link",
    ".rn-wishlist-sidebar-header",
    ".rn-wishlist-sidebar-overlay",
  ].forEach((selector) => {
    const element = document.querySelector(selector);
    if (element) {
      element.addEventListener("click", () =>
        sidebar.classList.toggle("is-active")
      );
    }
  });
}
const cartPage = document.querySelector(".c-cart-template__inner");

if (cartPage) {
  cartPage.addEventListener("click", async (e) => {
    const removeButton =
      e.target.classList.contains("c-cart-product__remove-link") ||
      e.target.closest(".c-cart-product__remove-link");

    if (removeButton) {
      const lineItemId = e.target
        .closest(".c-cart-product__remove")
        .getAttribute("line");

      if (!lineItemId) {
        console.error("No line item ID found");
        return;
      }

      // Prepare the data to update cart (setting quantity to 0 for removal)
      const formData = {
        id: lineItemId,
        quantity: 0,
      };

      try {
        const response = await fetch(
          window.Shopify.routes.root + "cart/change.js",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to update the cart");
        }

        const data = await response.json();
        // const product = e.target.closest('.c-cart-product')
        window.location.reload();

        // Optionally, you can refresh the cart or update the cart UI here.
      } catch (error) {
        console.error("Error:", error);
      }
    }
  });
}

const recommendation = document.querySelector(".rn-recommendation");

if (recommendation) {
  const url = recommendation.dataset.url;

  // Define an async function to use await
  const fetchRecommendation = async () => {
    try {
      const response = await fetch(url); // Fix the typo and use fetch

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.text();
      const parser = new DOMParser();
      const update_document = parser.parseFromString(data, "text/html");

      const currentRecommendationWrap = document.querySelector(
        ".rn-recommendation .c-product-recommendations__carousel-overflow"
      );
      const updateRecommendationWrap = update_document.querySelector(
        ".rn-recommendation .c-product-recommendations__carousel-overflow"
      );

      if (currentRecommendationWrap && updateRecommendationWrap) {
        currentRecommendationWrap.innerHTML =
          updateRecommendationWrap.innerHTML;
      }
    } catch (error) {
      console.error("Error fetching recommendations:", error);
    }
  };

  fetchRecommendation(); // Call the async function
}

document.body.addEventListener("click", (e) => {
  const closeButton = e.target.classList.contains(
    "c-cart-contents__close-icon"
  );

  if (closeButton) {
    const drawer = document.querySelector(".c-cart-drawer");
    drawer.classList.remove("is-drawer-open");
  }
});

const add_to_cart = async (formData, details) => {
  const data = {
    items: [formData],
  };
  try {
    // Await the fetch call to handle it asynchronously
    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    // Await the response to ensure it's resolved before logging it
    const data2 = await response.json();
    await getCart();
  } catch (error) {
    alert("Out Of Stock");
    console.error("Error adding item to cart:", error);
  } finally {
    if (details) {
      setTimeout(() => {
        details.classList.remove("is-loading");
        const card = details.closest(".o-product-thumbnail");
        card.classList.remove("is-active");
      }, 1000);
    }
    if (document.querySelector(".c-product-form__cta-wrap button")) {
      document
        .querySelector(".c-product-form__cta-wrap button")
        .removeAttribute("disabled");
      document.querySelector(".c-product-form__cta-wrap button").innerHTML =
        "Add to cart";
    }
  }
};

const openCart = (count) => {
  const cart_drawer = document.querySelector(".c-cart-drawer");
  cart_drawer.classList.add("is-drawer-open");

  let cart_bubble = document.querySelector(".c-header__cart-text[data-cart-count]");
  
  // If no cart bubble found — create one
  if (!cart_bubble) {
    const cartLink = document.querySelector(".c-header__cart");
    if (cartLink) {
      cart_bubble = document.createElement("span");
      cart_bubble.className = "c-header__cart-text o-paragraph--1";
      cart_bubble.setAttribute("data-cart-count", "");
      cartLink.appendChild(cart_bubble);
    }
  }

  if (cart_bubble) {
    let countSpan = cart_bubble.querySelector("span");

    // If inner span not exists — create one
    if (!countSpan) {
      countSpan = document.createElement("span");
      cart_bubble.appendChild(countSpan);
    }

    // Update the count
    countSpan.textContent = count;
  }
};

const getCartDrawerData = async (count) => {
  try {
    const response = await fetch(window.location.href, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.text();
    const parser = new DOMParser();
    const update_document = parser.parseFromString(data, "text/html");

    // Update cart drawer content
    const previous_drawer = document.querySelector(".c-cart-drawer");
    const update_drawer = update_document.querySelector(".c-cart-drawer");

    if (previous_drawer && update_drawer) {
      previous_drawer.innerHTML = update_drawer.innerHTML;
    }

    openCart(count);
  } catch (error) {
    console.error("Error:", error);
  }
};

// Get Cart Data
const getCart = async () => {
  try {
    const response = await fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    const count = data.item_count;
    await getCartDrawerData(count);
  } catch (error) {
    console.error("Error:", error);
  }
};

const collectionPage = document.querySelector("#product-grid");

function popupWishlist() {
  const products = JSON.parse(localStorage.getItem("wishlistProducts"));
  const heart = document.querySelector(".c-header__wishlist .wishlist-count");
  heart.innerText = products.length;
}

const wishlist = JSON.parse(localStorage.getItem("wishlistProducts")) || [];

function saveWishlist() {
  localStorage.setItem("wishlistProducts", JSON.stringify(wishlist));
  popupWishlist();
}

saveWishlist();

const products = document.querySelectorAll(".o-product-thumbnail");
products.forEach((product) => {
  if (wishlist.includes(product.href)) {
    const wishlistIcon = product.querySelector(".wishlist-icon");
    wishlistIcon.classList.add("active");
  }
});
const removeWishlistItem = (e, href) => {
  let wishlist = JSON.parse(localStorage.getItem("wishlistProducts")) || [];
  wishlist = wishlist.filter((link) => !link.includes(href));
  localStorage.setItem("wishlistProducts", JSON.stringify(wishlist));
  const article = e.target.closest("article");
  if (article) {
    article.remove();
  } else {
    console.error("Article element not found.");
  }
  const matchProduct = document.querySelector(
    `.o-product-thumbnail[href="${href.replace("https://engine.com.pk", "")}"]`
  ) || document.querySelector(`.save-button[data-url='${href.replace("https://engine.com.pk", "")}']`);

  if (matchProduct) {
    const icon = matchProduct.querySelector(".wishlist-icon") || matchProduct;
    if (icon) {
      icon.classList.remove("active");
    } else {
      console.error("Wishlist icon not found on the matching product.");
    }
  } else {
    console.error("Matching product not found for href:", href);
  }
  popupWishlist();
};

const productAdd = async (event) => {
  const variant_id = event.target.closest(".rn-wishlist-sidebar-article")
    .dataset.id;
  console.log("variant_id==>", variant_id);

  const formData = {
    id: +variant_id,
    quantity: 1,
  };

  await add_to_cart(formData);
};
const variantChange = (event) => {
  let article = event.target.closest(".rn-wishlist-sidebar-article");
  const id = event.target.value;
  article.setAttribute("data-id", id);
};

const arrayWishlist = async () => {
  const wishlist_arr =
    JSON.parse(localStorage.getItem("wishlistProducts")) || [];
  const wishlistContainer = document.querySelector(
    ".rn-wishlist-sidebar-content"
  );

  if (!wishlistContainer) {
    console.error("Wishlist container not found.");
    popupWishlist();
    return;
  }

  let wishlistContent = ""; // Collect all templates here

  const save_button = document.querySelector(
    ".c-product-template__details-inner .save-button"
  );
  if (save_button && wishlist_arr.includes(save_button.dataset.url)) {
    save_button.classList.add("active");
  }
  for (const single of wishlist_arr) {

    try {
      const response = await fetch(`${single}.js`);
      const data = await response.json();

      // Find the first available variant
      const availableVariant = data.variants.find(
        (variant) => variant.available
      );

      const template = `
    <article class="rn-wishlist-sidebar-article" data-id="${availableVariant && availableVariant.id
        }">
      <img src="${data.featured_image}" class="img-responsive" />
      <div class="rn-wishlist-sidebar-inner">
        <h3><a href="${data.url}">${data.title}</a></h3>
        ${data.price === data.compare_at_price
          ? `<p>Rs. ${(data.price / 100).toFixed(2)}</p>`
          : `<p><s>Rs. ${(data.compare_at_price / 100).toFixed(2)}</s> Rs. ${(
            data.price / 100
          ).toFixed(2)}</p>`
        }
        
        <div class="rn-wishlist-sidebar-buttons">
          <div class="rn-wishlist-sidebar-variants">
          ${availableVariant
          ? `<select class="rn-wishlist-sidebar" name="wishlist_variants" onChange="variantChange(event)">
              ${data.variants
            .filter((variant) => variant.available)
            .map(
              (variant) => `
                  <option value="${variant.id}">${variant.title}</option>
                `
            )
            .join("")}
            </select>`
          : ""
        }
          </div>
          
          ${availableVariant
          ? `<button class="rn-wishlist-cart-button is-tertiary o-btn" onClick="productAdd(event)">
              Add to cart
            </button>`
          : `<div class="rn-wishlist-out-of-stock is-tertiary o-btn">Out of stock</div>`
        }
          
          <button class="rn-wishlist-remove-button" onClick="removeWishlistItem(event,'${data.url
        }')">+</button>
        </div>
      </div>
    </article>
  `;

      wishlistContent += template; // Append the template to the collected content
    } catch (error) {
      console.error("Error fetching product:", error);
    }

  }

  // Insert all the templates into the container at once
  wishlistContainer.innerHTML = wishlistContent;

  if (wishlist_arr.length === 0) {
    console.log("No items in wishlist.");
    popupWishlist();
    return;
  }

  popupWishlist();
};

arrayWishlist();

const addWishlistPopup = async (url, state) => {
  try {
    const response = await fetch(`${url}.js`);
    const { id, title, featured_image } = await response.json();

    // Create template
    const template = document.createElement("div");
    template.className = "rn-wishlist-add-popup";
    template.dataset.id = id;
    template.innerHTML = `
      <div class="rn-wishlist-add-popup-left">
        <img src="${featured_image}" class="img-responsive" />
        <p>${title}</p>
      </div>
      <p>Item ${state}</p>
    `;

    const wrapper = document.querySelector(".rn-wishlist-add-popup-wrapper");
    if (wrapper) {
      wrapper.appendChild(template);
    }

    // Remove the popup after 3 seconds
    setTimeout(() => {
      const find_add_wishlist_product_item = document.querySelector(
        `.rn-wishlist-add-popup[data-id="${id}"]`
      );
      if (find_add_wishlist_product_item) {
        find_add_wishlist_product_item.remove();
      }
    }, 2000);
  } catch (error) {
    console.error("Error adding to wishlist:", error);
  }
};

if (collectionPage) {
  const cards = collectionPage.querySelectorAll(".o-product-thumbnail");

  cards.forEach((card) => {
    card.addEventListener("click", async (e) => {
          if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) {
    return;
  } 
      if (!card.classList.contains("is-active")) {
        const img = e.target.classList.contains(
          "o-product-thumbnail__hover-image"
        );
        if (img) {
          window.location.href = card.href;
        }
      }
     
      e.preventDefault();

      const wishlistIcon = e.target.closest(".wishlist-icon");
      if (wishlistIcon) {
        const productElement = wishlistIcon.closest(".o-product-thumbnail");
        wishlistIcon.classList.toggle("active");

        if (productElement) {
          const productLink = productElement.dataset.url;

          // Retrieve the wishlist from localStorage or initialize an empty array if it doesn't exist
          let wishlist =
            JSON.parse(localStorage.getItem("wishlistProducts")) || [];

          if (wishlistIcon.classList.contains("active")) {
            // Add the productLink to the wishlist if it's not already there
            if (!wishlist.includes(productLink)) {
              wishlist.push(productLink);
              addWishlistPopup(productLink, "Saved!");
            }
          } else {
            // Remove the productLink from the wishlist if the icon is deactivated
            wishlist = wishlist.filter((link) => link !== productLink);
            addWishlistPopup(productLink, "Removed!");
          }

          // Save the updated wishlist back to localStorage
          localStorage.setItem("wishlistProducts", JSON.stringify(wishlist));
          arrayWishlist();
        }
      }

      const quickButton =
        e.target.classList.contains("o-product-thumbnail__button") ||
        e.target.closest(".o-product-thumbnail__button");

      if (quickButton) {
        card.classList.add("is-active");
      }

      if (e.target.classList.contains("o-product-thumbnail__title")) {
        window.location.href = card.href;
      }

      if (
        !card.classList.contains("is-active") &&
        e.target.classList.contains("o-product-thumbnail__slideshow")
      ) {
        window.location.href = card.href;
      }

      if (
        (card.classList.contains("is-active") &&
          e.target.classList.contains("o-product-thumbnail__hover-image")) ||
        e.target.classList.contains("o-product-thumbnail__slideshow")
      ) {
        card.classList.remove("is-active");
      }

      const variant_select = card.querySelector(
        ".o-variant-selector__dropdown"
      );
      if (
        e.target.classList.contains("o-swatches__swatch-button") ||
        e.target.closest(".o-swatches__swatch-button")
      ) {
        const buttonTitle =
          e.target.getAttribute("title") ||
          e.target.closest(".o-swatches__swatch-button").getAttribute("title");

        Array.from(variant_select.options).forEach((option) => {
          if (
            option.dataset.option1 === buttonTitle ||
            option.dataset.option2 === buttonTitle
          ) {
            option.selected = true; // Set the option as selected
          }
        });

        if (variant_select.value != null) {
          const details = card.querySelector(".o-product-thumbnail__details");
          details.classList.add("is-loading");

          const formData = {
            id: +variant_select.value,
            quantity: 1,
          };

          await add_to_cart(formData, details);
        }
      }
    });
  });
}
const productPage = document.querySelector(".c-product-template");
if (productPage) {
  const variant_buttons = document.querySelectorAll(
    ".is-size .o-swatches__swatch-options.is-button button"
  );
  const variant_select = document.querySelector(
    ".o-variant-selector.o-swatches__variant-selector select"
  );
  const hidden_input = document.querySelector(
    '.c-product-form input[name="id"]'
  );

  variant_buttons.forEach((variant) => {
    variant.addEventListener("click", (e) => {

      const parent = variant.closest('.o-swatches__swatch')
      parent.querySelectorAll('.o-swatches__swatch-options.is-button button').forEach((variant) => {
        variant.removeAttribute("selected");
      });

      const current =
        e.target.tagName === "BUTTON" ? e.target : e.target.closest("button");

      current.setAttribute("selected", "is-selected");

      const buttonTitle = current.getAttribute("title");
      const variant_sku = document.querySelector('.rn-product-sku')
      Array.from(variant_select.options).forEach((option) => {

          if (option.dataset.option2 == buttonTitle || option.dataset.option1 == buttonTitle) {
            option.selected = true;
            hidden_input.value = +option.value;
            variant_sku.textContent = option.dataset.sku
          }
        
        
      });
    });
  });

  const product_wishlist_button = document.querySelector(
    ".c-product-form__cta-wrap .save-button"
  );

  product_wishlist_button.addEventListener("click", (e) => {
    if (
      e.target.classList.contains("save-button") ||
      e.target.closest(".save-button")
    ) {
      const wishlist_button = product_wishlist_button;

      wishlist_button.classList.toggle("active");

      const productLink = wishlist_button.dataset.url;

      let wishlist = JSON.parse(localStorage.getItem("wishlistProducts")) || [];

      if (wishlist_button.classList.contains("active")) {
        // Add the productLink to the wishlist if it's not already there
        if (!wishlist.includes(productLink)) {
          wishlist.push(productLink);
          addWishlistPopup(productLink, "Saved!");
        }
      } else {
        // Remove the productLink from the wishlist if the icon is deactivated
        wishlist = wishlist.filter((link) => link !== productLink);
        addWishlistPopup(productLink, "Removed!");
      }

      // Save the updated wishlist back to localStorage
      localStorage.setItem("wishlistProducts", JSON.stringify(wishlist));
      arrayWishlist();
    }
  });
}

const addToCart = document.querySelector(".c-product-form__cta-wrap button");
if (addToCart) {
  addToCart.addEventListener("click", async (e) => {
    e.preventDefault();

    const variant_select = document.querySelector(
      ".o-variant-selector.o-swatches__variant-selector select"
    );
    if (variant_select.value != null) {
      const formData = {
        id: +variant_select.value,
        quantity: 1,
      };

      await add_to_cart(formData);
    }
  });
}

window.Routes = {
  predictive_search_url: "/search/suggest",
};

document.addEventListener("DOMContentLoaded", (event) => {
  const announcementBar = document.querySelector(
    ".c-announcement.c-announcement--pill"
  );

  if (announcementBar) {
    setTimeout(() => {
      announcementBar.classList.add("is-initialised");
    }, 1000);
  }
});

const cart_container = document.querySelector("[data-cart-container]");
const toggleCart = (e) => {
  cart_container.classList.toggle("is-drawer-open");
  e.preventDefault();
};
document.querySelector(".c-header__cart").addEventListener("click", toggleCart);
document
  .querySelector("[data-cart-drawer-toggle]")
  .addEventListener("click", toggleCart);
document
  .querySelector(".c-cart-drawer__background")
  .addEventListener("click", toggleCart);

const all_product_cards = document.querySelectorAll(
  ".o-product-thumbnail.o-products-list__product-thumbnail"
);
if (all_product_cards.length > 0) {
  all_product_cards.forEach((thumb) => {
    thumb.addEventListener("click", async (e) => {
      // Video control handling
      if (e.target?.classList.contains("video-control")) {
        e.preventDefault();
        const parent = e.target.closest("a");
        if (parent) {
          const videoPlayer = parent.querySelector(
            ".o-product-thumbnail__video"
          );
          if (videoPlayer) {
            const video = videoPlayer.querySelector("video");
            if (video) {
              videoPlayer.classList.toggle("is-playing");

              if (videoPlayer.classList.contains("is-playing")) {
                video.play();
              } else {
                video.pause();
              }
            }
          }
        }
      }
    });
  });
}

const sizeGuideButton = document.querySelector("[data-size-guide-trigger]");

const sizeGuideShadow = (lightBox) => {
  if (!lightBox.shadowRoot) {
    const shadowRoot = lightBox.attachShadow({ mode: "open" });
    shadowRoot.innerHTML = `
          <style>
            * { box-sizing: border-box; }
    
            .container {
              display: none;
              justify-content: stretch;
              align-items: stretch;
            }
    
            .background {
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              opacity: 0;
              transition: all .2s cubic-bezier(.16,1,.3,1);
            }
    
            .wrapper {
              position: fixed;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              z-index: 1;
              overflow-y: auto;
              display: flex;
            }
    
            .inner {
              padding: 1rem;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            }
    
            .popup {
              box-sizing: border-box;
              position: relative;
              width: 100%;
              max-width: 62.5rem;
              margin: 0 auto;
              padding: 0.5rem;
              opacity: 0;
              transform: translateY(-2rem);
              transition: all .2s cubic-bezier(.16,1,.3,1);
            }
    
            .close-btn {
              background-color: transparent;
              border: none;
              cursor: pointer;
              display: flex;
              margin-left: auto;
              padding: .5rem;
            }
    
            .close-btn-icon {
              height: 1.125rem;
              width: 1.125rem;
            }
    
            .popup.compact { 
              max-width: 35rem;
              border-radius: 1.25rem!important;
            }
    
            .popup.compact .close-btn,
            .popup.media-zoom .close-btn {
              position: absolute;
              top: 8px;
              right: 8px;
              z-index: 1;
            }
    
            .popup.media-zoom .close-btn {
              top: 16px;
              right: 16px;
              background-color: rgba(255,255,255,.5);
              border-radius: 50%;
              padding: 10px;
            }
    
            .popup.media-zoom svg {
              width: 20px;
              height: 20px;
            }
    
            .popup.media-zoom path {
              stroke: rgba(255,255,255,1);
            }
    
            .popup.small { max-width: 30rem; }
            .popup.large { max-width: 80rem; }
            .container.is-visible { display: block; }
    
            .is-closing .popup { transform: translateY(2rem); }
            .is-open .background { opacity: 1; }
            .is-open .popup {
              opacity: 1;
              transform: translateY(0);
            }
    
            .popup.media-zoom {
              max-width: 750px;
              padding: 0!important; 
            }
    
            @media only screen and (max-width: 46.81rem) {
              .popup.mobile-bottom {
                align-self: flex-end;
                margin-bottom: -1rem;
                border-bottom-left-radius: 0!important;
                border-bottom-right-radius: 0!important;
                margin-left: -1rem;
                margin-right: -1rem;
                width: 100vw;
                transform: translateY(2rem);
                padding-top: 2rem;
              }
    
              .is-open .popup.mobile-bottom {
                transform: translateY(0);
              }
            }
    
            @media only screen and (min-width: 68.75rem) {
              .close-btn {
                padding: 1.5rem;
              }
    
              .close-btn-icon {
                height: 2rem;
                width: 2rem;
              }
    
              .popup.compact .close-btn {
                padding: .5rem;
                top: 16px;
                right: 16px;
              }
    
              .popup.media-zoom {
                padding: 0; 
              }
            }
          </style>
    
          <div part="root visible" class="container is-visible is-open">
            <div part="background" class="background"></div>
            <div part="wrapper" class="wrapper">
              <div part="inner" class="inner">
                <div part="popup" class="popup">
                  <button class="close-btn">
                    <svg class="close-btn-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18.75 5.25L5.25 18.75" stroke="#15151F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      <path d="M18.75 18.75L5.25 5.25" stroke="#15151F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </button>
                  <slot></slot>
                </div>
              </div>
            </div>
          </div>
        `;
  }
};

if (sizeGuideButton) {
  sizeGuideButton.addEventListener("click", (e) => {
    const lightBox = document.querySelector(
      "light-box[data-size-guide-lightbox]"
    );
    const isVisible = lightBox.getAttribute("visible") === "true";

    if (isVisible) {
      lightBox.setAttribute("visible", "false");
      lightBox.shadowRoot
        .querySelector(".container")
        .classList.remove("is-open");
      lightBox.shadowRoot
        .querySelector(".container")
        .classList.add("is-closing");
    } else {
      sizeGuideShadow(lightBox);
      lightBox.setAttribute("visible", "true");
      lightBox.shadowRoot.querySelector(".container").classList.add("is-open");
    }

    lightBox.shadowRoot
      .querySelector(".close-btn")
      .addEventListener("click", () => {
        lightBox.setAttribute("visible", "false");
        lightBox.shadowRoot
          .querySelector(".container")
          .classList.remove("is-open");
        lightBox.shadowRoot
          .querySelector(".container")
          .classList.add("is-closing");
      });
  });
}
